<template>
  <div class="main-box" >
    <div class="title">
    <strong  @click="$router.push('/meituanWaimaiProduct')" style="cursor:pointer"><i class="el-icon-back"></i></strong>
    <span @click="test" >菜品编辑</span>
</div>
<div class="nav-menu">
  <div  class="item" title="基础信息"><a href="#baseInfo">基础信息</a></div>
  <div class="item" title="菜品构成"><a href="#saleInfo">售卖信息</a></div>
  <div class="item" title="打印配置"><a href="#high">高级信息</a></div>
</div>
<div class="main-content">
<el-row>
    <el-col><div id="baseInfo" class="base-info"><span class="line" ></span> <span>基础信息</span></div></el-col>
</el-row>
<el-form :rules="rules" ref="form" :model="form" label-width="140px">
    <el-form-item prop="productName" label="菜品名称:" required>
    <el-input  v-model="form.productName" style="width:320px"></el-input>
  </el-form-item>
      <el-form-item  label="菜品分类:" required>
      <el-select  @change="changeSel"
      clearable value-key="categoryCode" v-model="productType" style="width:320px">
        <el-option :label="item.categoryName" :value="item" v-for="item,i in dishType" :key="i"></el-option>
      </el-select>
  </el-form-item>
  <el-form-item label="菜品价格:" prop="price">
    <el-input v-model="form.price" style="width:320px" placeholder="请输入菜品价格"></el-input>
  </el-form-item>
  <el-form-item label="餐盒价格:" prop="boxPrice" >
    <el-input v-model="form.boxPrice" style="width:320px" placeholder="请输入餐盒价格"></el-input>
  </el-form-item>
    <el-form-item label="餐盒数量:" prop="boxNum" >
    <el-input v-model.number="form.boxNum"  style="width:320px" placeholder="请输入餐盒数量"></el-input>
  </el-form-item>
      <el-form-item label="商品图片:">
    <el-upload
    :file-list="imgList"
    :limit="5"
    :before-upload="checkImg"
  :action="$uploadURL"
  list-type="picture-card"
  :on-preview="handlePictureCardPreview"
  :on-success="uploadSuccess"
  :on-remove="handleRemove">
  <i class="el-icon-plus"></i>
   <div slot="tip" class="el-upload__tip">只能上传jpg文件，且大小不超过2M</div>
</el-upload>
<el-dialog :visible.sync="dialogVisible">
  <img width="100%" :src="dialogImageUrl" alt="">
</el-dialog>
  </el-form-item>
<el-row>
    <el-col><div id="saleInfo" class="base-info"><span class="line" ></span> <span>售卖信息</span></div></el-col>
</el-row>
<!-- 菜品规格 -->
  <el-form-item label="菜品规格:">
    <div style="border:1px solid #e8e8e8;margin-bottom:16px" v-for="item,i in form.specsDimAttrList" :key="i">
      <div class="dishType-head">
        <div class="left"> <span  style="font-size:17px">规格 {{i+1}}</span>
         <span v-if="item.defaultFlag==1" class="default-text">默认</span></div>
           <div class="right"
  
            @click="deleteOne(i)"><span>删除</span></div>
      </div>
     <div style="padding:14px;padding-top:8px;padding-bottom:0"
      class="inline-form">
       <el-form v-if="form.specsDimAttrList[i]!=null"  :rules="rules" :model="form.specsDimAttrList[i]" :inline="true" label-position="top">
        <el-form-item label="规格名称" required >
          <el-select 
          @change="changeSel"
          v-model="item.sizeName"
           clearable value-key="dimCode" style="width:130px">
            <el-option  v-for="itemName,iName in typeName" :key="iName"
            :label="itemName.dimName"
            :value="itemName"
            ></el-option>
            <!-- <el-option value=" " ></el-option> -->
       <div style="font-size:14px;color:#ff6000;height:34px;cursor:pointer;
       display: flex;justify-content: center;align-items: center;
       position: absolute;bottom: 0;background: #fff;width: 128px"
       @click="$router.push('/merchantProductSpecification')"
       > <i style="margin-right:6px"
       class="el-icon-plus"></i><span>新建规格</span></div>
          </el-select>
        </el-form-item>
           <el-form-item 
           v-if="form.specsDimAttrList!=null && form.specsDimAttrList.length!=1"
           class="is-default" label="是否默认" >
          <el-radio label="1"  @change="doDefault(item,i)" v-model="item.defaultFlag">{{''}}</el-radio>
        </el-form-item>
        <el-form-item label="基础价格" required prop="normalPrice">
         <el-input v-model="item.normalPrice" style="width:130px">
            <span slot="suffix" style="color:#333;padding-right:8px">元</span>
         </el-input>
        </el-form-item>
                <el-form-item label="会员价" >
          <el-input v-model="item.memberPrice" style="width:130px">
              <span slot="suffix" style="color:#333;padding-right:8px">元</span>
          </el-input>
        </el-form-item>
          <el-form-item label="设置餐盒" >
          <el-input style="width:90px" v-model="item.lunchBoxPrice">
             <span slot="suffix" style="color:#333;padding-right:8px">元</span>
          </el-input>
        </el-form-item>
           <el-form-item label="预估成本" >
          <el-input v-model="item.costPrice" style="width:130px">
             <span slot="suffix" style="color:#333;padding-right:8px">元</span>
          </el-input>
        </el-form-item>
           <el-form-item label="条形码 " >
          <el-input v-model="item.barCode" style="width:130px" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
     </div>
    </div>
      <div class="addOne"
      @click="addOneType"
      ><i class="el-icon-plus"></i>
      <span style="margin-left:3px">添加多个规格</span></div>
  </el-form-item>
<el-form-item label="做法:" class="text-center">
  <div class="groupByType"
  v-show="item.attrList!=null && item.attrList.length!=0"
   v-for="item,i in form.practiceDimList" :key="i">
    <div class="top">
      <div class="left">分组 {{i+1}}: <span>{{item.dimName}}</span></div>
      <div @click="deleteOneGroup(i,item.dimName)" class="right"> 删除分组</div>
    </div>
      <el-table :data="item.attrList">
    <el-table-column align="center" label="序号" type="index"></el-table-column>
     <el-table-column align="center" label="名称" prop="attrName"></el-table-column>
      <el-table-column align="center" label="价格" prop="price"></el-table-column>
        <el-table-column label="操作"  align="center">
          <template slot-scope="scope">
            <span style="cursor:pointer" 
            @click="deleteSelectCook(i,scope.$index,scope.row.attrName)">删除</span>
          </template>
        </el-table-column>
  </el-table>
  </div>
  <el-button style="margin-top:12px" class="myBtn" @click="getLeftType">添加做法</el-button>
</el-form-item>
<el-form-item label="加料:" class="text-center">
    <div class="groupByType" 
     v-show="item.attrList!=null && item.attrList.length!=0"
    v-for="item,i in form.feedDimList" :key="i">
    <div class="top">
      <div class="left">分组 {{i+1}}: <span>{{item.dimName}}</span></div>
      <div  class="right" @click="doleteAddGroup(i,item.dimName)"> 删除分组</div>
    </div>
        <el-table :data="item.attrList" >
    <el-table-column align="center" label="序号" type="index"></el-table-column>
     <el-table-column align="center" label="名称" prop="attrName"></el-table-column>
      <el-table-column align="center" label="价格" prop="price"></el-table-column>
        <el-table-column label="操作"  align="center">
          <template slot-scope="scope">
            <span style="cursor:pointer" @click="deleteSelectAdd(i,scope.$index,scope.row.attrName)">删除</span>
          </template>
        </el-table-column>
  </el-table>
    </div>
  <el-button style="margin-top:12px" class="myBtn" @click="addBut()">添加加料</el-button>
</el-form-item>
<el-row>
    <el-col><div id="set" class="base-info"><span class="line" ></span> <span>售卖信息</span></div></el-col>
</el-row>
<el-form-item class="long-label" prop="rawMaterials" label="商品原料:" required>
  <el-input v-model="form.rawMaterials" style="width:189px" placeholder="请输入"></el-input>
</el-form-item>
<el-form-item class="long-label" label="商品描述:" >
 <el-input
   type="textarea"
  :autosize="{ minRows: 2, maxRows: 4}"
  placeholder="200字以内，请输入"
   maxlength="200"
  v-model="form.description">
</el-input>

</el-form-item>
<el-row>
    <el-col><div id="high" class="base-info"><span class="line" ></span> <span>高级信息</span></div></el-col>
</el-row>
<el-form-item  prop="minOrderCount" class="long-label label-content-flex" label="最少购买:" >
 <el-input
  placeholder="最少购买"
  v-model.number="form.minOrderCount"
  > 
</el-input> <span style="margin-left:8px">个</span>
</el-form-item>
<el-form-item label="售卖时间:">
 <el-time-picker
 value-format="HH:mm:ss"
 format="HH:mm:ss"
    is-range
    v-model="dataRange"
    range-separator="至"
    start-placeholder="开始时间"
    end-placeholder="结束时间"
    placeholder="选择时间范围">
  </el-time-picker>
</el-form-item>
<el-form-item label="店内招牌:">
    <el-switch
  v-model="speciality"
  active-color="#F59A23"
  inactive-color="#DCDFE6">
</el-switch>

</el-form-item>
<el-form-item label="单点不送:">
    <el-switch
    @change="isNotChange"
  v-model="isNotSingle"
  active-color="#F59A23"
  inactive-color="#DCDFE6">
</el-switch>

</el-form-item>
<el-form-item label="下架菜品:">
    <el-switch
  v-model="isSoldOut"
  active-color="#F59A23"
  inactive-color="#DCDFE6">
</el-switch>
</el-form-item>
</el-form>
<el-dialog
  title="做法选择"
   :before-close="handleClose"
  :visible.sync="dialogCookType"
  width="800px">
  <div class="box-main">
    <div class="left">
     <div
     @click="searchLeft('全部',-1,null)"
      :class="{'item':true,'active':leftTypeActive==-1}"
      >全部</div>
      <div
      @click="searchLeft(cook.dimName,index,cook.dimCode)"
      :class="{'item':true,'active':leftTypeActive==index}"
      v-for="cook,index in leftType" :key="index"
      >{{cook.dimName}}</div>
    </div>
    <div class="right">
      <div class="top">
        <el-input v-model="cookName" class="h32" placeholder="请输入做法名称"></el-input>
        <el-button class="h32 btn-my" style="margin-left:12px"
        @click="searchByName">
          <i style="font-size:16px;font-weight:700" class="el-icon-search"></i>
          查询</el-button>
        <el-button @click="reset"
        style="background:#fff" class="h32 btn-my">
          重置</el-button>
      </div>
      <el-table
      ref="tableRight"
      :row-key="getRowKeys"
      @selection-change="handleSelectionChange"
      :data="tableRight" width="100%" height="400px" style="font-size:14px;">
        <el-table-column :reserve-selection="true"   type="selection"></el-table-column>
        <el-table-column  width="60px" label="序号" type="index"></el-table-column>
        <el-table-column  label="做法名称" prop="attrName"></el-table-column>
        <el-table-column   label="变价金额" prop="price"></el-table-column>
        <el-table-column  label="做法组" prop="dimName"></el-table-column>
      </el-table>
    </div>
  </div>
    <!-- 已选项 -->
    <div style="margin-bottom:9px;color:#222;font-size:16px" v-if=" selectCook!=null &&  selectCook.length!=0">
      <span>已选 （{{selectCook.length}}）</span>
    </div>
    <div class="hasSelect">
      <div v-for="item,i in selectCook" :key="i"
      @click="cancelSelectCook(i,item.attrCode)"
       class="item">
        {{item.attrName}} <i class="el-icon-close"></i></div>
    </div>
    <!--  -->
  <span slot="footer" class="dialog-footer">
    <div @click="goToDetailCook" class="red">新建做法</div>
    <div>
      <el-button class="btnAll btnCancel" @click="dialogCookType = false">取 消</el-button>
    <el-button class="btnAll btnSubmit" type="primary" @click="cookTypeButton">确 定</el-button>
    </div>
  </span>
</el-dialog>
<!--  -->
<el-dialog
  title="加料选择"
   :before-close="handleClose"
  :visible.sync="dialogAddMore"
  width="800px">
  <div class="box-main">
    <div class="left">
            <div
             @click="searchLeft('全部',-1,null)"
            :class="{'item':true,'active':leftTypeActive==-1}"
      >全部</div>
      <div
      @click="searchLeft(cook.dimName,index,cook.dimCode)"
      :class="{'item':true,'active':leftTypeActive==index}"
      v-for="cook,index in AddLeft" :key="index"
      >{{cook.dimName}}</div>
    </div>
    <div class="right">
      <div class="top">
        <el-input v-model="addName" class="h32" placeholder="请输入做法名称"></el-input>
        <el-button
        @click="searchByAddName"
        class="h32 btn-my" style="margin-left:12px">
          <i style="font-size:16px;font-weight:700" class="el-icon-search"></i>
          查询</el-button>
        <el-button @click="reset"
        style="background:#fff" class="h32 btn-my">
          重置</el-button>
      </div>
      <el-table
       ref="tableRight"
       :row-key="getRowKeys"
      @selection-change="handleSelectionChangeAdd"
      :data="tableRight" width="100%" height="400px" style="font-size:14px;">
        <el-table-column :reserve-selection="true"   type="selection"></el-table-column>
        <el-table-column  width="60px" label="序号" type="index"></el-table-column>
        <el-table-column  label="做法名称" prop="attrName"></el-table-column>
        <el-table-column  label="变价金额" prop="price"></el-table-column>
        <el-table-column  label="做法组" prop="dimName"></el-table-column>
      </el-table>
    </div>
  </div>
      <!-- 已选项 -->
    <div style="margin-bottom:9px;color:#222;font-size:16px" v-if="selectAdd.length!=0">
      <span>已选 （{{selectAdd.length}}）</span>
    </div>
    <div class="hasSelect">
      <div v-for="item,i in selectAdd" :key="i"
      @click="cancelSelectAdd(i,item.attrCode)"
       class="item">
        {{item.attrName}} <i class="el-icon-close"></i></div>
    </div>
    <!--  -->
  <span slot="footer" class="dialog-footer">
    <div @click="goToDetailAdd" class="red">新建加料</div>
    <div>
    <el-button class="btnAll btnCancel" @click="dialogAddMore = false">取 消</el-button>
    <el-button class="btnAll btnSubmit" @click="addButton">确 定</el-button>
 </div>
  </span>
</el-dialog>
<!--  -->
<!-- 结束new -->
</div>
<div class="foot">
       <el-button @click="$router.push('/meituanWaimaiProduct')" class="btnAll btnCancel">取消</el-button>
       <el-button class="btnAll btnSubmit" @click="submit('form')">保存并创建
      <i v-if="saveLoading" class="el-icon-loading"></i>
    </el-button>
</div>
  </div>

</template>
<script>
export default {
  data() {
      var checkPrice = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('此项必填'));
        }
        var re = /^\d+(\.\d+)?$/
          if (!re.test(value)) {
            console.log('--')
            callback(new Error('请输入非负数'));
          } else {
            if (value < 0) {
              callback(new Error('价格不得为负'));
            } else {
              callback();
            }
          }
      };
          var checkBoxNum = (rule, value, callback) => {
        if (!value) {
          return callback();
        }
        var boxStr=/^\d+$/
          if (!boxStr.test(value)) {
            callback(new Error('请输入正整数'));
          } else {
            if (value < 0) {
              callback(new Error('价格不得为负'));
            } else {
              callback();
            }
          }
      };
      var checkMinOrderCount=(rule, value, callback) => {
        if(!value){
          return callback()
        }
        var minOrder=/^\d+$/
          if (!minOrder.test(value)) {
            callback(new Error('请输入非负整数'));
          } else {
            if (value < 0) {
              callback(new Error('价格不得为负'));
            } else {
              callback();
            }
          }
      };
    return {
        rules:{
            productName:[
            { required: true, message: '此项必填', trigger: ['blur','change'], },
            ],
            normalPrice:[
          { required: true, message: '此项必填', trigger: ['blur','change'], },
            ],
            rawMaterials:[
            { required: true, message: '此项必填', trigger: ['blur','change'], },
            ],
            minOrderCount:[
               { validator: checkMinOrderCount, trigger: ['blur'] },
            ],
            boxPrice:[
               { validator: checkPrice, trigger: ['blur'] },
               {required:true,message:"此项必填",trigger:['blur']}

            ],
            price:[
               { validator: checkPrice, trigger: ['blur'] },
               {required:true,message:"此项必填",trigger:['blur']}
            ],
            boxNum:[
               { validator: checkBoxNum, trigger: ['blur'] },
            ]
        },
        isNotChanged:true,
        top:true,
        imgArr:[],
        imgList:[],//file-list
        dialogImageUrl: '',
        dialogVisible: false,
        cookName:'',
        addName:"",
        rightTableData:{
        merchantCode:"",
        dimType:'practice',
        dimCode:'',
        attrName:'',
      },
    saveLoading:false,
    dialogAddMore:false,
    selectCook:[],
    selectAdd:[],
    leftDimName:"",
    leftType:[],
    AddLeft:[],
    tableRight:[],
    leftTypeActive:-1,
    dishType:[],//菜品分类下拉框
    typeName:[],//规格名称下拉
     productType:{categoryCode:'',categoryName:'' },  //菜品分类
    dialogCookType:false,
    dataRange:'',//售卖时间
    speciality:false,//店内招牌
    isNotSingle:false,//单点不送
    isSoldOut:false,//isSoldOut 菜品上下架状态
    form:{
      merchantCode:localStorage.getItem('merchantCode'),
      merchantName:localStorage.getItem('merchantName'),
      productName:"",//菜品名称
      categoryCode:'',//分类编码
      categoryName:"",//  分类名称
      picture:'',
      pictures:'',//商品图片
      rawMaterials:'',//商品原料
      description:'',//商品描述
      minOrderCount:'',//最少购买
      soldTimeBegin:'',
      soldTimeEnd:'',
      speciality:false,//店内招牌
      isNotSingle:0,//单点不送
      isSoldOut:1,//
      boxPrice:0,
      price:"",
      boxNum:'',
      specsDimAttrList:[{
        sizeName:{},
        dimName:'',
        defaultFlag:'1',
        normalPrice:'',
        memberPrice:'',
        costPrice:'',
        barCode:'',
        lunchBoxPrice:''
      },
      ],
      practiceDimList:[
      ], //做法
      // practiceList:[],
      feedDimList:[
      ],//加料
    }
    };
  },
  methods: {
    test(){
      var ree = /^\d+(\.\d+)?$/
      console.log(ree.test(this.form.boxPrice))
    },
    isNotChange(){
      this.isNotChanged=false
    },
    uploadSuccess(res,file){
        console.log(res,file)
        if(res.code==200){
            this.imgArr.push(res.data.url)
            console.log(this.imgArr)
        }
    },
    // 检查是否为png,jpeg的图片
    checkImg(file){
     const isJPG = (file.type === 'image/jpeg');
      const isLt2M = file.size / 1024 / 1024 < 2;
       if (!isJPG) {
          this.$message.error('上传图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M
    },
       handleRemove(file, fileList) {
        console.log(file, fileList,'移除',);
        this.imgArr.forEach((item,i)=>{
            if(item==file.response.data.url){
                this.imgArr.splice(i,1)
            }
        })
        
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
    reset(){
      this.rightTableData.dimCode=''
      this.rightTableData.attrName=''
      this.cookName=''
      this.addName=''
      this.getRightTable()
    },
     cancelSelectAdd(i,code){
        let row=this.tableRight.find(val=>{
          return val.attrCode===code
        })
        this.$refs.tableRight.toggleRowSelection(row,false)
      },
    // 删除做法分组
    deleteOneGroup(i,dimName){
     var arr=[]
    arr= this.selectCook.filter(p=>{
      return p.dimName!=dimName
     })
    //   console.log(arr,'删选后')
      this.selectCook=arr
      this.form.practiceDimList.splice(i,1)
    },
    // 删除加料分组
    doleteAddGroup(i,dimName){
      var arr=[]
    arr= this.selectAdd.filter(p=>{
      return p.dimName!=dimName
     })
    //   console.log(arr,'删选后')
      this.selectAdd=arr
      this.form.feedDimList.splice(i,1)
    },
    // 做法选择确认按钮
    cookTypeButton(){
    console.log(this.selectCook)
      let dataArr = [];
    this.selectCook.map(mapItem => {
      if (dataArr.length == 0) {
          dataArr.push({ dimName: mapItem.dimName, attrList: [mapItem] })
      } else {
         let res = dataArr.some(item=> {//判断
          if (item.dimName == mapItem.dimName) {
            item.attrList.push(mapItem)
            return true
          }
        })
        if (!res) {//
          dataArr.push({ dimName: mapItem.dimName, attrList: [mapItem] })
        }
      }
    })
    this.form.practiceDimList=dataArr
    //  console.log(dataArr,'66666666666',this.form.practiceDimList)
       this.dialogCookType = false
    //  获取到新数组
    },
    // 提交按钮
    submit(formName){
      this.saveLoading=true
    //   console.log(formName)
    console.log(this.$refs)
        this.$refs.form.validate((valid) => {
          if (valid) {
                 // this.form.practiceList=this.selectCook
      // this.form.feedList=this.selectAdd
      this.form.categoryCode=this.productType.categoryCode
      this.form.categoryName=this.productType.categoryName
      this.form.specsDimAttrList.forEach((item,index)=>{
        item.dimName=item.sizeName.dimName
        item.dimCode=item.sizeName.dimCode
        item.attrName='规格'+ (index+1)
      })
      this.form.feedDimList.forEach(item=>{
        item.dimCode=item.attrList[0].dimCode
      })
      this.form.practiceDimList.forEach(item=>{
        item.dimCode=item.attrList[0].dimCode
      })
      if(this.dataRange==null || this.dataRange==''){
        this.form.soldTimeBegin=null
        this.form.soldTimeEnd=null
      }else{
        this.form.soldTimeBegin=this.dataRange[0]
        this.form.soldTimeEnd=this.dataRange[1]
      }
      if(this.speciality==true){
        this.form.speciality=1}else{
        this.form.speciality=2
      } 
      if(this.isNotSingle==true){this.form.isNotSingle='1'}else{
        this.isNotChanged==true? this.form.isNotSingle=0 :this.form.isNotSingle=2
      }
      this.form.picture=this.imgArr[0]
      this.form.pictures=this.imgArr.join(',')
      if(this.isSoldOut==true){
        this.form.isSoldOut=0
      }else{
        this.form.isSoldOut=1
      }
      console.log(this.form,this.dataRange)
      this.$http.post('/meituanWaimaiProduct/updateMeituanProduct',this.form).then(res=>{
        // console.log(res)
        if(res.data.code==200){
          this.$message({type:'success',message:'保存成功'})
          this.saveLoading=false
          this.$router.push('/meituanWaimaiProduct')
        }else{
          this.$message.error(res.data.message)
           this.saveLoading=false
        }
      })
      this.saveLoading=false
          } else {
            this.$message.error('表单填写有误，请检查后重新提交')
            console.log('error submit!!');
           this.saveLoading=false
            return false;
          }
        });
    },
    deleteSelectCook(i,index,attrName){
      // this.selectCook.splice(i,1)
    //   console.log(i,index,this.form.practiceDimList,attrName,this.selectCook)
      this.form.practiceDimList[i].attrList.splice(index,1)
      // var needCook=[]
      this.selectCook.forEach((item,ItemIndex)=>{
        if(item.attrName==attrName){
          this.selectCook.splice(ItemIndex,1)
        }
      })
    //   console.log(this.selectCook,'去除后')
    },
    deleteSelectAdd(i,index,attrName){
      // console.log(i,index,this.form.practiceDimList,attrName,this.selectCook)
      this.form.feedDimList[i].attrList.splice(index,1)
      this.selectAdd.forEach((item,ItemIndex)=>{
        if(item.attrName==attrName){
          this.selectAdd.splice(ItemIndex,1)
        }
      })
    //   console.log(this.selectAdd,'去除后')
    },
    // 添加加料
 async  addBut(){
      console.log('-----')
      this.rightTableData.dimType='feed'
      this.leftTypeActive='-1'
      this.leftDimName='全部'
      this.rightTableData.dimCode=null
      this.getAddLeft()
      this.dialogAddMore=true
       this.top=false
      let re= await this.getRightTable()
      console.log(re)
        if(this.selectAdd!=null && this.selectAdd.length!=0){
          var need=this.selectAdd
          let arrAdd=[]
        this.$refs.tableRight.clearSelection();
        this.tableRight.forEach(ele=>{
            need.forEach(item=>{
                if(ele.attrCode==item.attrCode){
                    arrAdd.push(ele)
                }
            })
        })
            arrAdd.forEach(it=>{
            console.log('回显个数',it)
            this.$refs.tableRight.toggleRowSelection(it,true);
          })
 
                }else{
        this.$refs.tableRight.clearSelection();
                }
    },
 getRowKeys(row) { //唯一值
			return row.attrCode;
			},
      // 添加加料确认按钮
    addButton(){
      this.dialogAddMore = false
      let dataArr = [];
    this.selectAdd.map(mapItem => {
      if (dataArr.length == 0) {
          dataArr.push({ dimName: mapItem.dimName, attrList: [mapItem] })
      } else {
         let res = dataArr.some(item=> {//判断相同
          if (item.dimName == mapItem.dimName) {
            item.attrList.push(mapItem)
            return true
          }
        })
        if (!res) {//如果没找相同日期添加一个新对象
          dataArr.push({ dimName: mapItem.dimName, attrList: [mapItem] })
        }
      }
    })
    this.form.feedDimList=dataArr
    },
    handleSelectionChange(val){
      this.selectCook=val
      // console.log(val,'做法')
    },
    searchByName(){ //搜索
    this.rightTableData.attrName=this.cookName
    this.getRightTable()
    },
    searchByAddName(){
      this.rightTableData.attrName=this.addName
      this.getRightTable()
    },
    handleSelectionChangeAdd(val){
      this.selectAdd=val
    },
    searchLeft(dimName,index,dimCode){
      this.leftDimName=dimName
      this.leftTypeActive=index
      this.rightTableData.dimCode=dimCode
      this.getRightTable()
    },
  async getRightTable(){
    let r=await  this.$http.post('/merchantDimAttr/queryList',this.rightTableData).then( 
       res=>{
       this.tableRight = res.data.data
    //    this.$refs.tableRight.clearSelection()
       console.log('获取了table')
    //    做法回显
      })
      return r
    },
    doDefault(obj,i){
      this.form.specsDimAttrList.forEach(item=>{
        item.defaultFlag=''
      })
      this.form.specsDimAttrList[i].defaultFlag='1'
    },
    // 菜品分类下拉框
    getSelect(){
      this.$http.post('/merchantProductsCategory/queryList',{merchantCode:localStorage.getItem('merchantCode')}).then(res=>{
        this.dishType=res.data.data
      })
    },
    // 规格名称
    getTypeName(){
      this.$http.post('/merchantDim/queryLeftMenu',{merchantCode:this.form.merchantCode,dimType:'specs'}).then(res=>{
        this.typeName=res.data.data
      })
    },
    handleClose(){
        // this.$refs.tableRight.clearSelection()
        console.log('清空')
        this.dialogCookType=false
        this.dialogAddMore=false
    },
  async getLeftType(){
      this.dialogCookType=true
      this.leftTypeActive='-1'
      this.leftDimName='全部'
      this.rightTableData.dimCode=null
      this.rightTableData.dimType='practice'
       this.$http.post('/merchantDim/queryLeftMenu',{merchantCode:this.form.merchantCode,dimType:'practice'}).then(res=>{
        this.leftType=res.data.data
         })
    //    this.top=true
      let t=await this.getRightTable()
      console.log(t,this.selectCook)
         if(this.selectCook!=null && this.selectCook.length!=0 ){
            let needs=this.selectCook
            let arr=[]
              this.$refs.tableRight.clearSelection();
            //   debugger
            //   console.log(this.tableRight,this.selectCook)
             this.tableRight.forEach(ele=>{
                needs.forEach(val=>{
                    if(ele.attrCode===val.attrCode){
                        arr.push(ele)
                        console.log(ele)
                    }
                })
            })
                 arr.forEach(it=>{
            // console.log('回显次数',it.attrCode,needs)
            this.$refs.tableRight.toggleRowSelection(it,true);
          })
         }else{
           this.$refs.tableRight.clearSelection();
         }
        },
      getAddLeft(){
         this.$http.post('/merchantDim/queryLeftMenu',{merchantCode:this.form.merchantCode,dimType:'feed'}).then(res=>{
          this.AddLeft=res.data.data
         })
      },
    // 添加
    addOneType(){
      this.form.specsDimAttrList.push(
        {
        sizeName:{},
        dimName:'',
        defaultFlag:'',
        normalPrice:'',
        memberPrice:'',
        costPrice:'',
        barCode:'',
        lunchBoxPrice:''
      },
      )
    },
    // 删除
    deleteOne(i){
      this.form.specsDimAttrList.splice(i,1)
      var flag=false
      this.form.specsDimAttrList.forEach(item=>{
        if(item.defaultFlag==1){
          flag=true
          return
        }
        if(flag==false){
          this.form.specsDimAttrList[0].defaultFlag='1'
        }
      })
    },
          changeSel(val){
  this.$nextTick(() => {
    this.$forceUpdate()
    })
      },
      // 跳转做法
      goToDetailCook(){
    //    this.dialogCookType = false
        // this.$router.push('/merchantProductRecipes?add=true')
     let routeData = this.$router.resolve({ path: '/merchantProductRecipes', query: { add: true} });
       window.open(routeData.href, '_blank');
      },
      // 加料跳转
      goToDetailAdd(){
        // this.dialogCookType = false
        // this.$router.push('/merchantProductFeedingManagement?add=true')
     let routeDatas = this.$router.resolve({ path: '/merchantProductFeedingManagement', query: { add: true} });
       window.open(routeDatas.href, '_blank');
      },
      // 
      cancelSelectCook(i,code){
        let row=this.tableRight.find(val=>{
          return val.attrCode==code
        })
        // console.log(row)
        this.$refs.tableRight.toggleRowSelection(row,false);
        // this.selectCook.splice(i,1)
        // console.log(i)
      },
    //回显
    getLoadInfo(){
      var info={}
      info.productCode=this.$route.query.productCode
      info.merchantCode=localStorage.getItem('merchantCode')
      this.$http.post('/meituanWaimaiProduct/queryOne',info).then(res=>{
      this.form=res.data.data
        this.form.productType={}
// 
      console.log(res.data.data,'39999999')
      if(res.data.data.pictures!=null && res.data.data.pictures!=''){
      this.form.pictures=res.data.data.pictures.split(',')
      this.form.pictures.forEach(val=>{
        this.imgList.push({url:val})
      })
      }
// 
        this.form.productType.categoryCode=res.data.data.categoryCode
        this.form.productType.categoryName=res.data.data.categoryName
        this.form.specsDimAttrList.forEach(item=>{
          item.sizeName={}
          item.sizeName.dimName=item.dimName
          item.sizeName.dimCode=item.dimCode
           console.log(item,'--------------')
        })
       var arr=[]
       res.data.data.practiceDimList.forEach(item=>{
        item.attrList.forEach(it=>{
          arr.push(it)
        })
       })
       this.selectCook=arr
       var arrs=[]
       res.data.data.feedDimList.forEach(item=>{
           item.attrList.forEach(it=>{
          arrs.push(it)
        })
       })
       this.selectAdd=arrs
       this.$set(this.productType,this.productType.categoryCode,res.data.data.categoryCode)
       this.$set(this.productType,this.productType.categoryName,res.data.data.categoryName)
        this.productType.categoryCode=res.data.data.categoryCode
        this.productType.categoryName=res.data.data.categoryName
        // this.$set(this.dataRange[0],res.data.data.soldTimeBegin)
        // this.$set(this.dataRange[1],res.data.data.soldTimeEnd)
       if(res.data.data.soldTimeBegin!=null &&  res.data.data.soldTimeEnd!=null && res.data.data.soldTimeBegin!='' && res.data.data.soldTimeEnd!=''){
         this.$set(this, 'dataRange', [res.data.data.soldTimeBegin, res.data.data.soldTimeEnd]);
       }
       if(this.form.speciality==1){this.speciality=true}else{
        this.speciality=false
      } 
      if(this.form.isNotSingle==1){this.isNotSingle=true}else{
        this.isNotSingle=false
        if(this.form.isNotSingle==2){
        this.isNotChanged=false
      }
      }

      if(this.form.isSoldOut==1){
        this.isSoldOut=false
      }else{
        this.isSoldOut=true
      }
      // if(this.form.boxPrice==null){this.form.boxPrice=0}

    //    console.log(arr,'获取的选中项',res,this.dataRange,this.productType)
      })
    }
  },
  created() {
   this.form.merchantCode=localStorage.getItem('merchantCode')
   this.form.merchantName=localStorage.getItem('merchantName')
   this.rightTableData.merchantCode=localStorage.getItem('merchantCode')
   this.getSelect()
   this.getTypeName()
   if(this.$route.query.productCode!=='' && this.$route.query.productCode!=undefined){
    // console.log('回显')
    this.getLoadInfo()
   }
  },
  mounted() {
 }
};
</script>

<style lang="less" scoped>
.main-content{
    height: 65vh;
  overflow: auto;
  // margin-top: 20px;
  padding:20px;
  padding-top: 0;
      .line {
        display: inline-block;
        width: 4px;
        height: 18px;
        background-color: #ffbd00;
        margin-right: 5px;
        border-radius: 2px;
        margin-bottom: -4px;
    }
}
.main-box{
  background-color: #fff;
  padding-top: 16px;
  .nav-menu{
    padding-left: 32px;
    width: 100%;
   background-color: rgb(248,248,248);
    display: flex;
    .item{
      color: #333;
      height: 32px;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      width: 80px;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;
      a{
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
    .item:hover{
      color: #ff6000;
    }
  }
}
.title{
   padding-left: 24px;
    height: 24px;
    margin-bottom: 24px;
    // border-bottom: 2px solid #f6f6f6;
    display: flex;
    align-items: center;
    span{
        margin-left: 6px;
    }
    i,span{
      font-size: 18px;
    font-weight: 500;
    color: #222;
    }
}
    .base-info{
        margin: 30px 0px 30px 20px;
    }
/deep/ .el-form-item__label{
  color: #333;
}
/deep/.inline-form{
  .el-form--inline .el-form-item{
    margin-right: 14px;
  }
  .el-form-item__label{
    padding-bottom: 0 !important;
  }
}
.default-text{
 padding:0 7px;
 color:#fff;
 background:#ffd100;
 border:1px solid #e9e9e9;
 width:24px;
 line-height:21px;
 margin-left:6px;
 font-size: 12px;
 height: 21px;
 display: inline-block;
}
/deep/ .is-default{
  .el-form-item__content{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
  }
  .el-radio:last-child{
    margin-right: 0;
    transform: translateY(2px);
  }
}
/deep/ .el-radio__input.is-checked .el-radio__inner{
  border-color: #ffd100;
  background-color: #ffd100;
}
/deep/ .dishType-head{
  background-color: #f7f7f7;
  display: flex;
  justify-content: space-between;
  height:32px;
  padding-left:14px;
  color:#333;
  font-weight:500;
  .left{
    display: flex;
    align-items: center;
    
  }
  .right{
    margin-right: 18px;
    color: #ff6000;
    cursor: pointer;
  }
}
.addOne{
      display: flex;
    align-items: center;
    height: 40px;
    padding: 0 16px;
    cursor: pointer;
    border-radius: 4px;
    background: #f7f7f7;
    border: 1px solid #f7f7f7;
    font-weight: 500;
    color: #ff6000;
    font-size: 14px;

}
/deep/ .myBtn{
  background-color: #ffd100;
  color: #222;
}
/deep/ .myBtn:hover{
color: #222;
}
/deep/.box-main{
  display: flex;
  .left{
    display: flex;
    flex-direction: column;
    .item{
      width: 129px;
      height: 34px;
      margin-bottom: 12px;
      padding-left: 12px;
      line-height: 34px;
      color: #333;
    }
    .item.active{
      background-color: #FFF2CC;
    }
  }
  .right{
    width: 100%;
    padding-left: 12px;
    margin-left: 6px;
    border-left: 1px solid rgba(0,0,0,.09);
    .top{
      display: flex;
      margin-bottom: 28px;
      .h32{
        height: 34px;
        font-size: 14px;
      }
      .h32.btn-my{
        background-color: #ffbd00;
        color: #000;
        padding-left: 15px;
        padding-right: 15px;
      }
      .el-input__inner{
        height: 34px !important;
      }
      .h32.el-input.el-input--small{
        width: 202px;
      }
    }
  }
}
/deep/ thead th{
  color: #333;
  font-weight: 400 !important;
}
/deep/ .el-select{
  width: 320px;
}
/deep/ .el-radio__input.is-checked+.el-radio__label{
  color: #222;
}
/deep/ .long-label{
  display: flex;
  .el-form-item__label{
    width: 144px !important;
  }
  .el-form-item__content{
    margin-left: 0 !important;
  }
}
.foot{
    display: flex;
    justify-content: right;
    height: 100px;
    background-color: #fff;
    padding-right: 60px;
    
}
/deep/ .groupByType{
  margin-block-start:14px;
  border: 1px solid #e8e8e8;
  padding-left: 8px;
  padding-right: 8px;
  color: #333;
  font-weight: 500;
  .top{
    height: 38px;
    line-height: 38px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e8e8e8;
    .left{
      font-size: 14px;
    }
    .right{
      margin-right: 10px;
      cursor: pointer;
    }
  }
}
/deep/ .el-table-column--selection .cell{
  padding-left: 10px;
}
/deep/ .btnAll{
  background: #fff;
  color: #222;
   border:1px solid #DCDFE6;
}
/deep/ .btnCancel:hover{
  color: #222;
  border:1px solid #DCDFE6;
  
}
/deep/ .btnSubmit{
  background-color: #ffbd00;
}
/deep/ .text-center{
 label{
   transform: translateY(10px);
 }
}

/deep/ .dialog-footer{
  display: flex;
  justify-content: space-between;
  line-height: 30px;
  .red{
    color: #ff6000;
    font-size: 14px;
    cursor: pointer;
  }
}

/deep/ .hasSelect{
  display: flex;
  flex-wrap: wrap;
  .item{
    cursor: pointer;
    font-size: 12px;
    margin-right: 8px;
    margin-bottom: 8px;
    padding-left: 7px;
    padding-right: 7px;
    border: 1px solid #e5e5e5;
    color: #333;
    user-select: none;
    line-height: 20px;
    background-color: #fafafa;
  }
}
/deep/ .label-content-flex{
    .el-form-item__content{
   display: flex;
    }
}
</style>
